import { render, staticRenderFns } from "./ModuleNamesDropdown.vue?vue&type=template&id=5ddb7796&"
import script from "./ModuleNamesDropdown.vue?vue&type=script&lang=js&"
export * from "./ModuleNamesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports